
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","viewBox":"0 0 21 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.597 2.008L16.64 2A1.355 1.355 0 0118 3.35v3.125a1.353 1.353 0 01-1.358 1.344h-5.038a1.353 1.353 0 01-1.363-1.35V3.354a1.352 1.352 0 011.356-1.345zm4.948 4.356v-2.91l-4.85.009v2.901h4.85zM3.357 2l5.048.009a1.36 1.36 0 011.354 1.36v6.967A1.36 1.36 0 018.4 11.7H3.356A1.359 1.359 0 012 10.338V3.363A1.36 1.36 0 013.357 2zm4.946 1.463l-4.85-.01v6.79h4.85v-6.78zm.094 8.72h-5.04A1.351 1.351 0 002 13.532v3.113c.004.75.612 1.353 1.36 1.35l5.039.009a1.353 1.353 0 001.36-1.347v-3.122a1.356 1.356 0 00-1.362-1.35zm-.093 1.454v2.91l-4.85-.008v-2.902h4.85zm3.295-5.333h5.046A1.36 1.36 0 0118 9.666v6.965a1.36 1.36 0 01-1.356 1.363l-5.046.009a1.36 1.36 0 01-1.357-1.362V9.668A1.36 1.36 0 0111.6 8.304zm4.946 1.455l-4.85-.001v6.79l4.85-.009V9.76z"}})])
          )
        }
      }
    